import { useTranslation } from "react-i18next";

import { Button, Arrange } from "@aviary";
import { emersonRoutes } from "@emerson/data/emersonRoutes";
import { l } from "@emerson/locales/i18n";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import * as styles from "./AuthButtons.styles";

const AuthButtons = () => {
  const { t } = useTranslation();
  const { desktop } = useBreakpoints();

  const containerStyles = desktop.lessThan && styles.margin;

  return (
    <Arrange isFullWidth isWrapped={false} css={containerStyles}>
      <Button isFullWidth to={emersonRoutes.login} intention="primary">
        {t(l.header.Signin)}
      </Button>
      <Button isFullWidth to={emersonRoutes.practitionerSignup} intention="system">
        {t(l.header.Signup)}
      </Button>
    </Arrange>
  );
};

export { AuthButtons };
